export default "__VITE_ASSET__hasP9Iz2__"